import { AxiosError } from "axios";

import { getUserInternalAccessToken } from "@/api/access-token-backoffice";
import { buildPaginationQuery } from "@/helpers/request-helpers";
import { IPlatform } from "@/interfaces/platform.interfaces";
import { apiT2B } from "@/lib/axios";

const basePlatformsUrl = "api/v1/platform";

export async function getPlatforms(pagination: { pageNumber: number; pageSize: number }) {
  try {
    // Get internal access token first
    const { accessToken } = await getUserInternalAccessToken();

    const paginationQuery = buildPaginationQuery(pagination);
    const config = { headers: { Authorization: `Bearer ${accessToken}` } };

    const response = await apiT2B.get(`${basePlatformsUrl}?${paginationQuery}`, config);

    const sanitizedItems = response.data.items.map((item: IPlatform) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { appToken, appKey, ...rest } = item;
      return rest;
    });

    const sanitizedResponse = {
      ...response.data,
      items: sanitizedItems,
    };

    return sanitizedResponse;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw new Error(error.response?.data?.message || "Failed to fetch platforms");
    }
    throw new Error("Something went wrong");
  }
}
